import { useState } from 'react';

/**
 * Custom hook that provides dynamic time functionality.
 *
 * @param updateIntervalMs - The interval in milliseconds at which the dynamic time should be updated.
 * @returns An object containing the current dynamic time, a function to stop and update the dynamic time,
 *          and a function to start the dynamic time.
 */
export const useDynamicTime = (updateIntervalMs: number) => {
  const [dynamicTime, setDynamicTime] = useState(new Date());
  const [currentInterval, setCurrentInterval] = useState<NodeJS.Timer | null>(
    null,
  );

  /**
   * Stops and updates the dynamic time.
   */
  const updateAndStopDynamicTime = () => {
    if (currentInterval) {
      setDynamicTime(new Date());
      clearInterval(currentInterval);
      setCurrentInterval(null);
    }
  };

  /**
   * Starts the dynamic time with the given interval.
   */
  const startDynamicTime = () => {
    const interval = setInterval(() => {
      setDynamicTime(new Date());
    }, updateIntervalMs);
    setCurrentInterval(interval);
  };
  return {
    dynamicTime,
    updateAndStopDynamicTime,
    startDynamicTime,
  };
};
